export interface IRiskTemplateListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    riskCategoryCode: string;
    activeState: number;
}

export class RiskTemplateListItem implements IRiskTemplateListItem {
    id: string;
    companyId: string;
    code: string;
    comment: string;
    riskCategoryCode: string;
    activeState: number;

    constructor();
    constructor(obj: IRiskTemplateListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.riskCategoryCode = obj && obj.riskCategoryCode || "";
        this.activeState = obj && obj.activeState || 0;
    }
}